import React, { useState } from 'react';
import { Check, X, Sparkles, Shield, Users, User, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { TopBar } from '../components/TopBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function PricingPage() {
  const [isAnnual, setIsAnnual] = useState(true);
  return <div className="flex flex-col min-h-screen w-full font-inter bg-white" data-id="element-3526">
      <TopBar data-id="element-3527" />
      <Header data-id="element-3528" />

      {/* Hero Section */}
      <section className="w-full bg-white py-16 md:py-24 border-b border-gray-200" data-id="element-3529">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center" data-id="element-3530">
          <h1 className="text-4xl md:text-6xl font-extrabold text-[#111111] mb-6 leading-tight" data-id="element-3531">
            Simple, Honest Pricing for Your
            <br className="hidden md:block" data-id="element-3532" /> Family's Digital Future.
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-3533">
            No upsells, no confusing add-ons, and no fear-mongering. Just
            straightforward plans that build your family's digital confidence.
            Choose the plan that's right for you.
          </p>

          {/* Monthly/Annual Toggle */}
          <div className="mt-12 flex items-center justify-center space-x-4" data-id="element-3534">
            <span className={`text-lg font-medium ${!isAnnual ? 'text-[#111111]' : 'text-gray-500'}`} data-id="element-3535">
              Monthly
            </span>
            <button onClick={() => setIsAnnual(!isAnnual)} className="relative w-16 h-8 bg-#[631bb7] rounded-full p-1 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-#[631bb7]" data-id="element-3536">
              <div className={`w-6 h-6 bg-white rounded-full shadow-md transform transition-transform duration-200 ease-in-out ${isAnnual ? 'translate-x-8' : 'translate-x-0'}`} data-id="element-3537" />
            </button>
            <span className={`text-lg font-medium ${isAnnual ? 'text-[#111111]' : 'text-gray-500'}`} data-id="element-3538">
              Annual <span className="text-[#631bb7] text-sm" data-id="element-3539">(Save 20%)</span>
            </span>
          </div>
        </div>
      </section>

      {/* Pricing Tiers */}
      <section className="w-full bg-[#f8f8f8] py-16 md:py-24" data-id="element-3540">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-3541">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start" data-id="element-3542">
            {/* Foundation (Free) */}
            <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm flex flex-col h-full" data-id="element-3543">
              <div className="mb-6" data-id="element-3544">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-3545">
                  Foundation
                </h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-3546">
                  Essential basics for everyone
                </p>
              </div>
              <div className="mb-8" data-id="element-3547">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-3548">
                  $0
                </span>
                <span className="text-gray-500 ml-1" data-id="element-3549">/forever</span>
              </div>
              <Link to="/intro-assessment" className="w-full block text-center py-3 px-4 bg-gray-100 text-[#111111] font-bold rounded-lg hover:bg-gray-200 transition-colors mb-8" data-id="element-3550">
                Start for Free
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-3551">
                <li className="flex items-start" data-id="element-3552">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-3553" />
                  <span className="text-gray-700 text-sm" data-id="element-3554">1 Member</span>
                </li>
                <li className="flex items-start" data-id="element-3555">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-3556" />
                  <span className="text-gray-700 text-sm" data-id="element-3557">
                    Basic Security Assessment
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3558">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-3559" />
                  <span className="text-gray-700 text-sm" data-id="element-3560">
                    Intro & Level 1 Modules
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3561">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-3562" />
                  <span className="text-gray-700 text-sm" data-id="element-3563">
                    Specialized Guides
                  </span>
                </li>
              </ul>
            </div>

            {/* Individual */}
            <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm flex flex-col h-full relative" data-id="element-3564">
              <div className="mb-6" data-id="element-3565">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-3566">
                  Individual
                </h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-3567">
                  Full access for one person
                </p>
              </div>
              <div className="mb-8" data-id="element-3568">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-3569">
                  {isAnnual ? '$79' : '$7.99'}
                </span>
                <span className="text-gray-500 ml-1" data-id="element-3570">
                  {isAnnual ? '/year' : '/mo'}
                </span>
                {isAnnual && <p className="text-green-600 text-sm mt-1 font-medium" data-id="element-3571">
                    Save $16/year
                  </p>}
              </div>
              <Link to="/intro-assessment" className="w-full block text-center py-3 px-4 bg-[#1a0647] text-white font-bold rounded-lg hover:bg-[#2d0b75] transition-colors mb-8" data-id="element-3572">
                Choose Individual
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-3573">
                <li className="flex items-start" data-id="element-3574">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-3575" />
                  <span className="text-gray-700 text-sm" data-id="element-3576">1 Member</span>
                </li>
                <li className="flex items-start" data-id="element-3577">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-3578" />
                  <span className="text-gray-700 text-sm" data-id="element-3579">
                    Everything in Foundation
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3580">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-3581" />
                  <span className="text-gray-700 text-sm font-semibold" data-id="element-3582">
                    Full Access to All 37 Modules
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3583">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-3584" />
                  <span className="text-gray-700 text-sm" data-id="element-3585">
                    Personal Dashboard & Scoring
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3586">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-3587" />
                  <span className="text-gray-700 text-sm" data-id="element-3588">
                    Personalized Task Queue
                  </span>
                </li>
              </ul>
            </div>

            {/* Family (Best Value) */}
            <div className="bg-white rounded-2xl p-8 border-2 border-[#631bb7] shadow-xl flex flex-col h-full relative transform md:-translate-y-4" data-id="element-3589">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#631bb7] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide" data-id="element-3590">
                Best Value
              </div>
              <div className="mb-6 mt-2" data-id="element-3591">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-3592">Family</h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-3593">
                  Complete protection for everyone
                </p>
              </div>
              <div className="mb-8" data-id="element-3594">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-3595">
                  {isAnnual ? '$199' : '$19.99'}
                </span>
                <span className="text-gray-500 ml-1" data-id="element-3596">
                  {isAnnual ? '/year' : '/mo'}
                </span>
                {isAnnual && <p className="text-green-600 text-sm mt-1 font-medium" data-id="element-3597">
                    Save $40/year
                  </p>}
              </div>
              <Link to="/intro-assessment" className="w-full block text-center py-3 px-4 bg-[#631bb7] text-white font-bold rounded-lg hover:bg-[#521099] transition-colors mb-8 shadow-md" data-id="element-3598">
                Choose Family
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-3599">
                <li className="flex items-start" data-id="element-3600">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-3601" />
                  <span className="text-gray-700 text-sm font-bold" data-id="element-3602">
                    Up to 6 Members
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3603">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-3604" />
                  <span className="text-gray-700 text-sm" data-id="element-3605">
                    Everything in Individual
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3606">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-3607" />
                  <span className="text-gray-700 text-sm font-semibold" data-id="element-3608">
                    Family Coordination Dashboard
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3609">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-3610" />
                  <span className="text-gray-700 text-sm" data-id="element-3611">
                    Role-Based Views
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3612">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-3613" />
                  <span className="text-gray-700 text-sm" data-id="element-3614">
                    Shared Task Queue & Delegation
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3615">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-3616" />
                  <span className="text-gray-700 text-sm" data-id="element-3617">
                    Cross-Family Progress Tracking
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Lifetime Offer Section */}
      <section className="w-full bg-[#1a0647] py-16 md:py-24 relative overflow-hidden" data-id="element-3618">
        {/* Background decorative elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-3619">
          <div className="absolute top-10 left-10 w-64 h-64 bg-[#8041bf] rounded-full filter blur-3xl" data-id="element-3620"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#00f4f8] rounded-full filter blur-3xl" data-id="element-3621"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-3622">
          <div className="text-center mb-12" data-id="element-3623">
            <div className="inline-block bg-[#631bb7] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-3624">
              Limited-Time Founding Member Offer
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-3625">
              Become a Founding Member.
              <br data-id="element-3626" /> Pay Once, Protected Forever.
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-3627">
              For our first 1,000 customers, we're offering exclusive lifetime
              access. Secure your family's digital future and support our
              mission to make the internet a safer place for everyone. This
              offer will not be available again.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-3628">
            {/* Lifetime Individual */}
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-2xl p-8 border border-white border-opacity-20 hover:bg-opacity-15 transition-all" data-id="element-3629">
              <div className="flex items-center justify-between mb-6" data-id="element-3630">
                <h3 className="text-2xl font-bold text-white" data-id="element-3631">
                  Lifetime Individual
                </h3>
                <User className="text-[#00f4f8] w-8 h-8" data-id="element-3632" />
              </div>
              <div className="mb-6" data-id="element-3633">
                <span className="text-5xl font-extrabold text-white" data-id="element-3634">$199</span>
                <p className="text-[#00f4f8] font-medium mt-2" data-id="element-3635">
                  One-Time Payment
                </p>
              </div>
              <p className="text-gray-300 mb-8" data-id="element-3636">
                Includes all future updates to the Individual Plan.
              </p>
              <button className="w-full py-4 px-6 bg-white text-[#1a0647] font-bold rounded-lg hover:bg-gray-100 transition-colors" data-id="element-3637">
                Get Lifetime Individual
              </button>
            </div>

            {/* Lifetime Family */}
            <div className="bg-gradient-to-br from-[#631bb7] to-[#521099] rounded-2xl p-8 border border-white border-opacity-20 shadow-2xl transform md:scale-105" data-id="element-3638">
              <div className="flex items-center justify-between mb-6" data-id="element-3639">
                <h3 className="text-2xl font-bold text-white" data-id="element-3640">
                  Lifetime Family
                </h3>
                <Users className="text-white w-8 h-8" data-id="element-3641" />
              </div>
              <div className="mb-6" data-id="element-3642">
                <span className="text-5xl font-extrabold text-white" data-id="element-3643">$599</span>
                <p className="text-white text-opacity-90 font-medium mt-2" data-id="element-3644">
                  One-Time Payment
                </p>
              </div>
              <p className="text-white text-opacity-80 mb-8" data-id="element-3645">
                Includes all future updates to the Family Plan for up to 6
                members.
              </p>
              <button className="w-full py-4 px-6 bg-[#00f4f8] text-[#1a0647] font-bold rounded-lg hover:bg-[#00e0e4] transition-colors shadow-lg" data-id="element-3646">
                Get Lifetime Family
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Competitive Comparison */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-3647">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-3648">
          <div className="text-center mb-12" data-id="element-3649">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-4" data-id="element-3650">
              Why Overpay for Anxiety When You Can Invest in Capability?
            </h2>
          </div>

          <div className="overflow-x-auto" data-id="element-3651">
            <table className="w-full max-w-5xl mx-auto border-collapse" data-id="element-3652">
              <thead data-id="element-3653">
                <tr data-id="element-3654">
                  <th className="text-left py-4 px-6 font-bold text-gray-500 uppercase text-sm tracking-wider border-b-2 border-gray-100" data-id="element-3655"></th>
                  <th className="text-left py-4 px-6 border-b-2 border-[#631bb7]" data-id="element-3656">
                    <div className="text-xl font-bold text-[#631bb7]" data-id="element-3657">
                      Caveo
                    </div>
                  </th>
                  <th className="text-left py-4 px-6 border-b-2 border-gray-100" data-id="element-3658">
                    <div className="text-xl font-bold text-gray-600" data-id="element-3659">
                      Norton 360 / Aura
                    </div>
                  </th>
                  <th className="text-left py-4 px-6 border-b-2 border-gray-100" data-id="element-3660">
                    <div className="text-xl font-bold text-gray-600" data-id="element-3661">
                      Geek Squad
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-3662">
                {[{
                label: 'Philosophy',
                caveo: 'Builds your capability',
                competitor1: 'Sells reactive alerts & fear',
                competitor2: 'Profits from your tech breaking'
              }, {
                label: 'Cost',
                caveo: 'Starts at $7.99/mo',
                competitor1: '$12 - $35/mo',
                competitor2: '$99+ per incident'
              }, {
                label: 'Experience',
                caveo: 'Plain-English guidance',
                competitor1: 'Confusing technical jargon',
                competitor2: 'In-person visit required'
              }, {
                label: 'Incentive',
                caveo: 'We win when you feel confident',
                competitor1: 'They win when you stay anxious',
                competitor2: 'They win when you have problems'
              }, {
                label: 'Outcome',
                caveo: 'Digital Independence',
                competitor1: 'Dependency & Confusion',
                competitor2: 'A temporary fix'
              }].map((row, idx) => <tr key={idx} className={idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-3663">
                    <td className="py-6 px-6 font-bold text-[#111111]" data-id="element-3664">
                      {row.label}
                    </td>
                    <td className="py-6 px-6 font-medium text-[#631bb7] bg-[#631bb7] bg-opacity-5" data-id="element-3665">
                      {row.caveo}
                    </td>
                    <td className="py-6 px-6 text-gray-600" data-id="element-3666">
                      {row.competitor1}
                    </td>
                    <td className="py-6 px-6 text-gray-600" data-id="element-3667">
                      {row.competitor2}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="w-full bg-[#f8f8f8] py-16 md:py-24 border-t border-gray-200" data-id="element-3668">
        <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-3669">
          <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-12 text-center" data-id="element-3670">
            Your Questions, Answered.
          </h2>
          <div className="space-y-6" data-id="element-3671">
            {[{
            q: 'Can I cancel my subscription at any time?',
            a: 'Yes. You can cancel your monthly or annual plan at any time from your account settings. No questions asked. Your plan will remain active until the end of the current billing period.'
          }, {
            q: 'What happens when you add new modules or features?',
            a: "All new modules and feature updates are included in the Individual, Family, and Lifetime plans at no extra cost. Our platform is constantly evolving to meet new threats, and you'll always have the latest protection."
          }, {
            q: 'How does the Family Plan work for different family members?',
            a: "The Family Plan gives you a central dashboard to invite up to 5 other family members. You can use our role-based views to see different information; for example, an adult child can see their parent's progress and help them with tasks, while the parent sees a simplified view focused on their own learning."
          }, {
            q: 'Is the Free (Foundation) plan free forever?',
            a: "Yes. The Foundation plan is free forever. It's a great way to get started with our basic security assessment and introductory modules to see how Caveo works."
          }, {
            q: 'What if I’m not satisfied?',
            a: "We offer a 30-day money-back guarantee on all paid plans, including lifetime memberships. If you're not happy for any reason, just let us know within 30 days of your purchase for a full refund."
          }].map((faq, index) => <div key={index} className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm" data-id="element-3672">
                <h3 className="text-lg font-bold text-[#111111] mb-2" data-id="element-3673">
                  {faq.q}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-3674">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-3675">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center" data-id="element-3676">
          <h2 className="text-3xl md:text-5xl font-bold text-[#111111] mb-6" data-id="element-3677">
            Ready to build your family's digital confidence?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-10" data-id="element-3678">
            Take the first step toward a safer, simpler digital life. Start with
            a free assessment or choose a plan to unlock the full power of Caveo
            today.
          </p>
          <Link to="/intro-assessment" className="inline-block bg-#[631bb7] text-white px-10 py-4 rounded-lg font-bold text-lg hover:bg-#[521099] transition-all shadow-lg transform hover:-translate-y-1" data-id="element-3679">
            Get Started for Free
          </Link>
        </div>
      </section>

      <Footer data-id="element-3680" />
    </div>;
}